import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import CategoryList from "@/components/feature/CategoryList";

export default function GuidePage() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryList category="guide" />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}